import { isLocalhost } from '@xylabs/sdk-react'

const Log = {
  debug: isLocalhost()
    ? (message: string) => {
        console.log(message)
      }
    : () => {
        return
      },

  error: (message: string) => {
    console.error(message)
  },
}

export default Log
